/** @jsx jsx */
import { useClipboard } from "@cd2/components"
import { css, jsx } from "@emotion/core"
import React from "react"
import { useSiteAlerts } from "../../hooks/useSiteAlerts"

export function CopyLink({ text, children }: { text: string; children?: React.ReactNode }) {
  const copy = useClipboard()
  const alerts = useSiteAlerts()
  return (
    <span
      onMouseUp={() => copy(text).then(() => alerts.genericSuccess(`Copied ${text}`))}
      title={text}
      css={css`
        cursor: pointer;
        border: 1px solid #ccc;
        padding: 0.25rem;
        white-space: nowrap;
        :hover {
          background-color: #f0f0f0;
        }
      `}
    >
      {children || text}
    </span>
  )
}
